import {PModuleType} from '@/enums/configs';
import {EntityModule} from '@/store/modules/entities/entityModule';
import dtcpTahoModule from '@/store/modules/entities/pmodules/dtcp/dtcpTahoStoreModule';
import pcrmModule from '@/store/modules/entities/pmodules/pcrmStoreModule';
import pcleanStorageModule from '@/store/modules/entities/pmodules/pcleanStorageStoreModule';
import pserverMonitorModule from '@/store/modules/entities/pmodules/pserverMonitorStoreModule';
import pheatermonitorModule from '@/store/modules/entities/pmodules/pheatermonitorStoreModule';
import pbearingControlModule from '@/store/modules/entities/pmodules/pbearingControlStoreModule';
import ppingerModule from '@/store/modules/entities/pmodules/ppingerStoreModule';
import {EntityDBModule} from '@/store/modules/entities/entityDBStorageModule';
import dtcpServerModule from '@/store/modules/entities/pmodules/dtcp/dtcpServerStoreModule';
import dtcpEnergyModule from '@/store/modules/entities/pmodules/dtcp/dtcpEnergyStoreModule';
import dtcpTemperatureModule from '@/store/modules/entities/pmodules/dtcp/dtcpTemperatureStoreModule';
import dtcpAccelerometerModule from '@/store/modules/entities/pmodules/dtcp/dtcpAccelerometerStoreModule';
import dtcpEmulatorModule from '@/store/modules/entities/pmodules/dtcp/dtcpEmulatorStoreModule';
import MainTab from '@/views/system/nodes/developerInfo/MainTab.vue';
import LastDBRecordsTab from '@/views/system/nodes/developerInfo/LastDBRecordsTab.vue';
import LogTab from '@/views/system/nodes/developerInfo/LogTab.vue';
import BrockerLogsTab from '@/views/system/nodes/developerInfo/BrokerLogsTab.vue';
import {PMActionType} from '@/views/system/modules/enums';
import {VueConstructor} from 'vue/types/umd';
import StartRecordActionComponent from '@/components/system/developerInfo/StartRecordAction.vue';
import CalibrationTableActionComponent from '@/components/system/developerInfo/CalibrationTableAction.vue';
import FullSpectrumActionComponent from '@/components/system/developerInfo/FullSpectrumAction.vue';
import RawSignalActionComponent from '@/components/system/developerInfo/RawSignalAction.vue';
import pmonitorStatesTask from '@/store/modules/entities/pmodules/pmonitorStatesTask';
import pmonitorBoundaryTask from '@/store/modules/entities/pmodules/pmonitorBoundaryTask';
import pmonitorChildTask from '@/store/modules/entities/pmodules/pmonitorChildTask';
import trendtaskModule from '@/store/modules/trendtaskModule';
import {IpModuleInterface} from './interfaces';

export const pmonitorTypes: IpModuleInterface[] = [
  {
    description: 'Задача определения режимов работы оборудования',
    type: PModuleType.MonitorStatesTasks,
    url: 'monitor-states-tasks',
    value: 'MonitorStatesTasks',
  },
  {
    description: 'Задача определения состояния оборудования (светофор)',
    type: PModuleType.MonitorBoundaryTasks,
    url: 'monitor-boundary-tasks',
    value: 'MonitorBoundaryTasks',
  },
  {
    description: 'Задача определения статуса по дочерним задачам',
    type: PModuleType.MonitorChildTasks,
    url: 'monitor-child-tasks',
    value: 'MonitorChildTasks',
  },
];

//TODO убрать EntityDBModule
export const pmoduleStoresByTypeMap: Map<PModuleType, EntityModule | EntityDBModule> = new Map<
  PModuleType,
  EntityModule | EntityDBModule
>([
  [PModuleType.CrmModule, pcrmModule],
  [PModuleType.DtcpTahoModule, dtcpTahoModule],
  [PModuleType.HeaterMonitorModule, pheatermonitorModule],
  [PModuleType.DtcpServerModule, dtcpServerModule],
  [PModuleType.DtcpEnergyModule, dtcpEnergyModule],
  [PModuleType.DtcpTemperatureModule, dtcpTemperatureModule],
  [PModuleType.DtcpAccelerometerModule, dtcpAccelerometerModule],
  [PModuleType.CleanStorageModule, pcleanStorageModule],
  [PModuleType.ServerMonitorModule, pserverMonitorModule],
  [PModuleType.BearingControlModule, pbearingControlModule],
  [PModuleType.PingerModule, ppingerModule],
  [PModuleType.DtcpEmulatorModule, dtcpEmulatorModule],
  [PModuleType.MonitorStatesTasks, pmonitorStatesTask],
  [PModuleType.MonitorBoundaryTasks, pmonitorBoundaryTask],
  [PModuleType.MonitorChildTasks, pmonitorChildTask],
  [PModuleType.SignalTrendTasks, trendtaskModule],
]);

export const pmoduleDataRoutesByTypeMap: Map<PModuleType, string> = new Map<PModuleType, string>([
  [PModuleType.CrmModule, 'crmModuleNew'],
  [PModuleType.DtcpTahoModule, 'dtcpTahoModuleNew'],
  [PModuleType.DtcpServerModule, 'dtcpServerModuleNew'],
  [PModuleType.DtcpEnergyModule, 'dtcpEnergyModuleNew'],
  [PModuleType.DtcpTemperatureModule, 'dtcpTemperatureModuleNew'],
  [PModuleType.DtcpAccelerometerModule, 'dtcpAccelerometerModuleNew'],
  [PModuleType.CleanStorageModule, 'cleanStorageModuleNew'],
  [PModuleType.ServerMonitorModule, 'serverMonitorModuleNew'],
  [PModuleType.BearingControlModule, 'bearingControlModuleNew'],
  [PModuleType.PingerModule, 'pingerModuleNew'],
  [PModuleType.HeaterMonitorModule, 'heaterMonitorModuleNew'],
  [PModuleType.DtcpEmulatorModule, 'dtcpEmulatorModuleNew'],
  //  [PModuleType.MonitorStatesTasks, ''],
  //  [PModuleType.MonitorBoundaryTasks, ''],
  //  [PModuleType.MonitorChildTasks, ''],
  [PModuleType.SignalTrendTasks, 'SignalTrendTasksShow'],
]);

export const pmoduleEventBoundaryPassedDataRoutesByTypeMap: Map<PModuleType, string> = new Map<
  PModuleType,
  string
>([
  [PModuleType.CrmModule, 'crmModuleEventBoundaryPassed'],
  [PModuleType.DtcpTahoModule, 'dtcpTahoModuleEventBoundaryPassed'],
  [PModuleType.DtcpServerModule, 'dtcpServerModuleEventBoundaryPassed'],
  [PModuleType.DtcpEnergyModule, 'dtcpEnergyModuleEventBoundaryPassed'],
  [PModuleType.DtcpTemperatureModule, 'dtcpTemperatureModuleEventBoundaryPassed'],
  [PModuleType.DtcpAccelerometerModule, 'dtcpAccelerometerModuleEventBoundaryPassed'],
  [PModuleType.CleanStorageModule, 'cleanStorageModuleEventBoundaryPassed'],
  [PModuleType.ServerMonitorModule, 'serverMonitorModuleEventBoundaryPassed'],
  [PModuleType.BearingControlModule, 'bearingControlModuleEventBoundaryPassed'],
  [PModuleType.PingerModule, 'pingerModuleEventBoundaryPassed'],
  [PModuleType.DtcpEmulatorModule, 'dtcpEmulatorModuleEventBoundaryPassed'],
]);

export const pmoduleProblemLogDataRoutesByTypeMap: Map<PModuleType, string> = new Map<
  PModuleType,
  string
>([
  [PModuleType.CrmModule, 'crmModuleProblemLog'],
  [PModuleType.ServerMonitorModule, 'serverMonitorModuleProblemLog'],
  [PModuleType.CleanStorageModule, 'cleanStorageModuleProblemLog'],
  [PModuleType.DtcpTahoModule, 'dtcpTahoModuleProblemLog'],
  [PModuleType.DtcpServerModule, 'dtcpServerModuleProblemLog'],
  [PModuleType.DtcpEnergyModule, 'dtcpEnergyModuleProblemLog'],
  [PModuleType.DtcpTemperatureModule, 'dtcpTemperatureModuleProblemLog'],
  [PModuleType.DtcpAccelerometerModule, 'dtcpAccelerometerModuleProblemLog'],
  [PModuleType.BearingControlModule, 'bearingControlModuleProblemLog'],
  [PModuleType.PingerModule, 'pingerModuleProblemLog'],
  [PModuleType.HeaterMonitorModule, 'heaterMonitorModuleProblemLog'],
]);

export const pmoduleDeveloperInfoDataRoutesByTypeMap: Map<PModuleType, string> = new Map<
  PModuleType,
  string
>([
  [PModuleType.CrmModule, 'crmModuleDeveloperInfo'],
  [PModuleType.DtcpTahoModule, 'dtcpTahoModuleDeveloperInfo'],
  [PModuleType.DtcpServerModule, 'dtcpServerModuleDeveloperInfo'],
  [PModuleType.DtcpEnergyModule, 'dtcpEnergyModuleDeveloperInfo'],
  [PModuleType.DtcpTemperatureModule, 'dtcpTemperatureModuleDeveloperInfo'],
  [PModuleType.DtcpAccelerometerModule, 'dtcpAccelerometerModuleDeveloperInfo'],
  [PModuleType.HeaterMonitorModule, 'heaterMonitorModuleDeveloperInfo'],
  [PModuleType.CleanStorageModule, 'cleanStorageModuleDeveloperInfo'],
  [PModuleType.ServerMonitorModule, 'serverMonitorModuleDeveloperInfo'],
  [PModuleType.BearingControlModule, 'bearingControlModuleEventDeveloperInfo'],
  [PModuleType.PingerModule, 'pingerModuleEventDeveloperInfo'],
  [PModuleType.DtcpEmulatorModule, 'dtcpEmulatorModuleDeveloperInfo'],
  [PModuleType.MonitorStatesTasks, 'monitorStatesTasksDeveloperInfo'],
  [PModuleType.MonitorBoundaryTasks, 'monitorBoundaryTasksDeveloperInfo'],
  [PModuleType.MonitorChildTasks, 'monitorChildTasksDeveloperInfo'],
  [PModuleType.SignalTrendTasks, 'signalTrendTasksDeveloperInfo'],
]);

export const pmoduleDeveloperInfoTabs = [
  {tab: 'main', title: 'Основная информация', view: MainTab},
  {tab: 'db', title: 'Последние записи из БД', view: LastDBRecordsTab},
  {tab: 'broker', title: 'Онлайн события брокера', view: BrockerLogsTab},
  {tab: 'log', title: 'Просмотр лога работы', view: LogTab},
];

export const pmoduleActionsByTypeMap: Map<PModuleType, Array<PMActionType>> = new Map<
  PModuleType,
  Array<PMActionType>
>([[PModuleType.DtcpTahoModule, [PMActionType.StartRecord]]]);

export const actionComponentsByTypeMap: Map<PMActionType, VueConstructor> = new Map<
  PMActionType,
  VueConstructor
>([
  [PMActionType.StartRecord, StartRecordActionComponent],
  [PMActionType.GetCalibrationTable, CalibrationTableActionComponent],
  [PMActionType.GetFullSpectrum, FullSpectrumActionComponent],
  [PMActionType.GetRawSignal, RawSignalActionComponent],
]);
